<div #layoutOrder class="layout-order animated fadeIn">
  <div class="layout-order__main" [ngClass]="{'w-100': !isMobile() && odooOrder()?.isSkipped}">
    <!-- Breadcrumbs -->
    <div class="row">
      <div class="col">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a [routerLink]="['/shop']"><span
                  class="material-symbols-outlined">home</span></a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              <span class="fw-bold">Order</span>
            </li>
          </ol>
        </nav>
      </div>
    </div>

    <div class="text-center text-sm-start">
      @if (odooOrder()?.isSkipped) {
      <h2 class="h2-semibold mb-2">You've skipped your order!</h2>
      <p class="">You will not be receiving your order this week.</p>
      } @else{
      <h2 class="h2-semibold mb-2">Your Delivery Order</h2>

      @if (isTemporaryRouteChange()) {
      <app-empty-message [message]="temporaryRouteChangeMessage()"></app-empty-message>
      }

      @if(!marketStatus().isOpen) {
      <div class="closed-market-container animated fadeIn mt-0 mb-3">
        <div class="alert" role="alert">
          <span class="material-symbols-outlined mat-icon-fill icon">
            calendar_today
          </span>
          <div class="text-container">

            <p class="header">{{closedMarket().title}}</p>
            <p class="legend">{{closedMarket().legend}}</p>
          </div>
        </div>
      </div>
      }
      }
    </div>


    <div>
      <!-- NEXT DELIVERY DATE -->
      <div class="order-info__item animated fadeIn">
        <div class="order-info__item-icon">
          <i class="material-symbols-outlined">local_shipping</i>
        </div>
        <div class="order-info__item-value">
          <h5 class="order-info__item-title">
            @if (!deliveryInfo()) {
            <span class="spinner-grow spinner-grow-sm" aria-hidden="true"></span>
            <span class="visually-hidden" role="status">Loading...</span>
            } @else {
            {{deliveryInfo()?.deliveryDateText}}
            }
          </h5>

          <p class="order-info__item-text h6-regular">
            @if (!deliveryInfo()) {
            <span class="spinner-grow spinner-grow-sm" aria-hidden="true"></span>
            } @else {
            {{ deliveryInfo()?.deliveryWindow }}
            }
          </p>

          <p class="order-info__item-text h6-regular">
            @if (!deliveryInfo()) {
            <span class="spinner-grow spinner-grow-sm" aria-hidden="true"></span>
            <span class="visually-hidden" role="status">Loading...</span>
            } @else {
            Edit before
            <span class="order-info__item-text__semibold">
              {{deliveryInfo()?.cutoffDateText}}
            </span>
            }
          </p>

        </div>
      </div>
    </div>


    <div class="order-info">
      <!-- DELIVERY ADDRESS -->
      @defer (on viewport; when this.signalsStoreService.sessionSignal()) {
      <div>
        <div class="order-info__item is-outline mb-0">
          <div class="order-info__item-icon">
            <span class="material-symbols-outlined">home</span>
          </div>
          <div class="order-info__item-value">
            <div class="order-info__item-title">{{addressInfo()?.title}}</div>
            <span class="d-flex flex-column">
              <p class="p-0 m-0 ">
                {{ addressInfo()?.text }}
              </p>
            </span>
          </div>
        </div>
        <div class="text-end">
          <a class="badge link-color" [routerLink]="['/settings/account/deliveries']">
            Manage Deliveries
          </a>
        </div>
      </div>
      } @placeholder {
      <div class="placeholder-glow animated fadeIn">
        <div class="placeholder col-12 py-5 bg-secondary"></div>
      </div>
      }
      <!-- PAYMENT METHOD -->
      @defer (on viewport; when this.signalsStoreService.sessionSignal()) {
      <div>
        <div class="order-info__item has-action is-outline mb-0">
          <div class="order-info__item-icon">
            <span class="material-symbols-outlined">credit_card</span>
          </div>
          <div class="order-info__item-value">
            <div class="order-info__item-title">Payment Method</div>
            <p class="card-text pt-0">**** ****
              **** {{ signalsStoreService.sessionSignal()?.creditCard?.number }}</p>
          </div>
          <div>
          </div>
        </div>
        <div class="text-end">
          <a class="badge link-color" [routerLink]="['/settings/billing/payment-method']">
            Manage Payments
          </a>
        </div>
      </div>
      } @placeholder {
      <div class="placeholder-glow animated fadeIn">
        <div class="placeholder col-12 py-5 bg-secondary"></div>
      </div>
      }
    </div>
    <hr>

    <!-- Undo delivery skip -->
    @if (isCheckedSkipWeekDelivery || odooOrder()?.isSkipped) {
    <section class="d-flex">
      <div class="animated fadeIn">
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault"
            [(ngModel)]="isCheckedSkipWeekDelivery" (change)="onChangeSkipWeekDelivery()">
          <label class="form-check-label animated fadeIn h7-regular" for="flexSwitchCheckDefault">Skipped</label>
        </div>
      </div>
    </section>
    }


    <section class="row justify-content-between">
      <!-- REVIEW CART - PENDING CHANGES -->
      @if (hasPendingChanges()) {
      <div class="alert alert-warning d-flex align-items-center animated fadeIn" role="alert">
        <i class="fa fa-info-circle text-primary me-2"></i>
        <div class="h7-regular">
          Review your cart, then click <b>Update Order</b> to reserve all items you've selected
        </div>
      </div>
      }

      <!-- Skipped subscriptions -->
      @if (skippedSubscriptions() && skippedSubscriptions()?.length) {

      <div class="col-6 mb-2 mt-2">
        <a class="h6-regular link-primary link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover"
          data-bs-toggle="collapse" href="#skippedSubscriptionsContainer" role="button" aria-expanded="false"
          aria-controls="skippedSubscriptionsContainer">
          Skipped Subscriptions for this week
        </a>
      </div>

      <div class="col-6 mb-2 mt-2 text-end ">
        <a [routerLink]="['/settings/account/subscriptions']" class="badge text-black pe-0">Manage Subscriptions</a>
      </div>

      <div class="col-12 py-3 border-0 animated fadeInDown collapse show skippedSubscriptionsContainer"
        id="skippedSubscriptionsContainer"
        [ngClass]="{'opacity-25 fadeIn': isCheckedSkipWeekDelivery && isConfirmedSkipWeekDelivery || odooOrder()?.isSkipped}">

        <div class="alert alert-warning d-flex align-items-center animated fadeIn" role="alert">
          <div class="h7-regular">
            The products in this section are not in your current order because you chose to skip them for this delivery.
            You can add them back by clicking <b><i>'Unskip'</i></b> on each skipped product.
          </div>
        </div>
        @for (product of skippedSubscriptions(); let productIdx = $index; track productIdx) {
        <div class="product-la-carte">
          <div class="product-la-carte__img">
            <a [routerLink]="['/shop/'+(product?.productUrl || '')]">
              <img [src]="product?.img || 'assets/images/product-placeholder.webp'" class="thumb-img"
                (error)="handleImageError($event)">
            </a>
          </div>
          <div class="product-la-carte__left">
            <a class="card-title" [routerLink]="['/shop/'+(product?.productUrl || '')]">
              <h5 class="card-title">{{ product.name }}</h5>
            </a>
            <p class="card-text pt-0 mb-0">
              @if (product?.variant?.attribute?.name) {
              {{ product?.variant?.attribute?.name }}: {{ product?.variant?.attribute?.value?.name }}
              } @else if (product?.package) {
              Package: {{ product?.package?.name }}
              }
              @if (product?.subscription) {
              {{ ((product?.package?.name || product?.variant?.attribute?.name) ? ' | ' : '') + 'Frequency: ' +
              product.subscription?.frequency?.name }}
              }
            </p>
            @if (product?.presentation) {
            <p class="card-text pt-0 my-1">
              {{ product.presentation.quantity }}
              {{ product.presentation.type }}
            </p>
            }
            <div class="row-field animated fadeIn">
              <div class="row-field__input">
                <mat-form-field class="rounded-selector d-flex" subscriptSizing="dynamic">
                  <input type="text" matInput readonly="true" [value]="product.quantity">
                </mat-form-field>
              </div>

              @if(!isMobile()) {

              @if (product?.bundle && product?.bundle?.items?.length) {
              <div class="border-start btn-delete__wrap">
                <small class="text-decoration-underline cursor-pointer">
                  <span class="link-underline" data-bs-toggle="collapse"
                    [attr.href]="'#skippedBundleContent'+product.id" role="button" aria-expanded="false"
                    [attr.aria-controls]="'#skippedBundleContent'+product.id">What's inside</span>
                </small>
              </div>
              }

              <div class="col border-start btn-delete__wrap">
                <small class="text-decoration-underline cursor-pointer" (click)="unskipProduct(product)">Unskip</small>
              </div>

              }

            </div>
          </div>
          <div class="product-la-carte__right">
            <span class="badge bg-info">Skipped</span>
          </div>
        </div>

        @if(isMobile()) {
        <div class="w-100 d-flex justify-content-between">
          <button class="btn btn-outline-secondary btn-product-action-mobile"
            (click)="unskipProduct(product)">Unskip</button>

          @if (product?.bundle && product?.bundle?.items?.length) {
          <button class="btn btn-outline-secondary btn-product-action-mobile" data-bs-toggle="collapse"
            [attr.data-bs-target]="'#skippedBundleContent'+product.id" aria-expanded="false"
            [attr.aria-controls]="'#skippedBundleContent'+product.id">What's inside</button>
          }
        </div>
        }

        @if (product?.bundle && product?.bundle?.items?.length) {
        <div class="row animated fadeIn collapse" [id]="'skippedBundleContent'+product.id">
          <div class="col-12 bg-light">
            @for (bundleProduct of product?.bundle?.items; track $index) {
            <div class="row d-flex justify-content-between p-3 py-1 animated fadeIn">
              <div class="col-6">
                <h6 class="card-title">{{ bundleProduct.name }} {{bundleProduct.packageName ? (' | ' +
                  bundleProduct.packageName) : (bundleProduct.display ? (' | ' + bundleProduct.display) : '')}}</h6>
                @if (bundleProduct?.presentation) {
                <small class="card-text">
                  {{ bundleProduct.presentation.quantity }}
                  {{ bundleProduct.presentation.type }}
                </small>
                }
              </div>
              <div class="col-6 d-flex justify-content-center align-content-center flex-wrap">
                <mat-form-field class="rounded-selector d-flex" subscriptSizing="dynamic">
                  <input type="text" matInput [value]="bundleProduct.quantity" readonly="true">
                </mat-form-field>

              </div>
            </div>
            }
          </div>

          <div class="col-12 d-flex justify-content-center align-content-center flex-wrap">
            <button class="btn btn-sm btn-outline-secondary mx-2" data-bs-toggle="collapse"
              [attr.data-bs-target]="'#skippedBundleContent'+product.id" aria-expanded="false"
              [attr.aria-controls]="'#skippedBundleContent'+product.id">
              Close
            </button>
          </div>
        </div>

        }

        <hr>

        }

      </div>


      }

      <!-- Subscriptions -->

      @if (subscriptionsLoaded()) {

      <div class="col-6 mb-2 mt-2">
        <h6 class="h6-regular">
          Subscriptions
        </h6>
      </div>

      <div class="col-6 mb-2 mt-2 text-end ">
        <a [routerLink]="['/settings/account/subscriptions']" class="badge pe-0 link-color">Manage Subscriptions</a>
      </div>
      }

      @if (!odooOrder()) {
      <div class="loading-animation-content my-5">
        <div class="loader">
          @for (item of [0,0,0,0,0]; track $index) {
          <div class="bg-secondary"></div>
          }
        </div>
        <h2 class="text-center">
          Just a moment — we're loading your order products!
        </h2>
      </div>
      } @else if (odooOrder() && (!subscriptionsLoaded() && !commonLoaded())) {
      <!-- Empty message -->
      <div class="d-flex flex-column align-items-center justify-content-center text-center py-4 my-5">
        <span class="material-symbols-outlined text-body-secondary"
          style="font-size: 48px; line-height: 1;">shopping_bag</span>
        <p class="fw-semibold mt-3 mb-1">No products in your order yet</p>
        <p class="mb-3 text-body-secondary">Add items to your cart to see them here.</p>
        <a [routerLink]="['/shop']" class="btn btn-sm btn-outline-secondary">Browse Products</a>
      </div>
      } @else {
      <div id="orderAccordion">
        <div class="col-12 border-0 animated py-3 position-relative"
          [ngClass]="{'opacity-25 fadeIn': isCheckedSkipWeekDelivery && isConfirmedSkipWeekDelivery || odooOrder()?.isSkipped}">
          @if (subscriptionsLoaded()) {
          <div id="orderSubscriptionAccordion">
            @for (product of products().subscription; let productIdx = $index; track productIdx) {
            <app-order-product [product]="product" [isSubscription]="true"
              [accordionParentId]="'orderAccordion'"></app-order-product>
            }
          </div>
          }
          @if (isCheckedSkipWeekDelivery && isConfirmedSkipWeekDelivery || odooOrder()?.isSkipped) {
          <div class="card-img-overlay text-center d-flex gap-3 flex-column"></div>
          }
        </div>

        <!-- A la carte -->
        @if (commonLoaded()) {
        <section>
          <div class="mb-2 mt-2">
            <p>A la carte</p>
          </div>

          <div id="orderCommonAccordion">
            @for (product of products().common; track $index) {
            <app-order-product [product]="product" [isSubscription]="false"
              [accordionParentId]="'orderAccordion'"></app-order-product>
            }
          </div>
        </section>
        }
      </div>
      }

    </section>

    @if (carouselFavoritesProducts()?.length) {
    <div class="product-highlight">
      <h3 class="product-highlight__title">Your Favorites</h3>
      <div class="product-highlight__body">
        <app-carousel [items]="carouselFavoritesProducts()"></app-carousel>
      </div>
    </div>
    }
    @if (carouselBuyAgainProducts()?.length) {
    <div class="product-highlight">
      <h3 class="product-highlight__title">Buy Again</h3>
      <div class="product-highlight__body">
        <app-carousel [items]="carouselBuyAgainProducts()"></app-carousel>
      </div>
    </div>
    }
    @if (carouselSuggestedProducts()?.length) {
    <div class="product-highlight">
      <h3 class="product-highlight__title">Other people also added</h3>
      <div class="product-highlight__body">
        <app-carousel [items]="carouselSuggestedProducts()"></app-carousel>
      </div>
    </div>
    }
  </div>

  @if (odooOrder()?.isSkipped) {
  <!-- SKIPPED ORDER -->
  <div class="layout-order__sidebar p-4 animated fadeInRight" [ngClass]="{'d-none': !isMobile()}">
    <!-- INFORMATION MESSAGE -->
    @if (odooOrder()?.invoiceDetails?.donation?.amount) {
    <div class="card border-0 mt-4 animated fadeInRight">
      <div class="row justify-content-between">
        <div class="col text-center">
          <h5>Thank you for your donation!</h5>
          <p>
            You've donated
            <b>{{ (odooOrder()?.invoiceDetails?.donation?.amount) | currency }}</b>
            to help us feed our local community.
            <a routerLink="/pages/about-us/donations" target="_blank" class="fw-bold">Learn more</a>
            about our donation program.
          </p>
        </div>
      </div>
    </div>
    }
  </div>
  } @else if (!isConfirmedSkipWeekDelivery) {
  <!-- ORDER SUMMARY -->
  <div class="layout-order__sidebar animated fadeInRight">
    <div>
      <div>
        <h2 class="h2-semibold text-center">Order Summary</h2>
      </div>

      <div class="d-grid gap-2 mt-2 mb-3">
        @if (!isAllowedOrder()) {
        <div class="d-flex align-items-center alert alert-warning animated fadeIn" role="alert">
          <i class="fa fa-info-circle me-2"></i>
          <div class="h7-regular">
            You have not yet reached the minimum sub-total order amount <b>({{this.odooOrder()?.paymentDetails?.minOrder
              | currency}})</b> to be able to save your order.
          </div>
        </div>
        }

      </div>
    </div>

    <!-- BILLING DETAIL -->
    <div class="card border-0 fw-bold">
      <!-- Subtotal -->
      <div class="row row-cols-2 justify-content-between">
        <div class="col">Subtotal</div>
        <div class="col text-end animated fadeIn">{{ subTotal().toFixed(2) | currency }}</div>
      </div>

      <!-- Get free delivery -->
      @if (deliveryFee() && showFreeDeliverySlider()) {
      <div class="row pt-2">
        <section class="d-flex align-items-center gap-2 justify-content-around order-scale">
          <small class="">Get free delivery</small>
          <mat-progress-bar mode="determinate" [value]="percentMinSpendForFreeDelivery()"></mat-progress-bar>
          <small class="">{{ minSpendForFreeDelivery() | currency }}</small>
        </section>
      </div>
      }

      <!-- Taxes -->
      <div class="row row-cols-2 pt-2 justify-content-between">
        <div class="col">Taxes</div>
        <div class="col text-end animated fadeIn">{{ taxes().toFixed(2) | currency }}</div>
      </div>

      <!-- Delivery Fee -->
      <div class="row row-cols-2 pt-2 justify-content-between">
        <div class="col">Delivery</div>
        <div class="col text-end animated fadeIn">
          @if (deliveryFee()) {
          <span class="animated fadeIn">{{ deliveryFee() | currency }}</span>
          } @else {
          <span class="animated fadeIn">FREE</span>
          }
        </div>
      </div>

      <!-- Get free delivery -->
      @if (hasMembershipFlow() && !signalsStoreService.sessionSignal()?.settings?.hasMembership) {
      <div class="text-end">
        <a [routerLink]="['/settings/billing/membership']" class="badge text-black" target="_blank">Get Free Delivery
          with Roots Rewards</a>
      </div>
      }
      <hr>

      <!-- Tip -->
      @if (shouldShowTipsAndDonations()) {
      <div class="row row-cols-2 pt-2 justify-content-between animated fadeInRight">
        <div class="col">
          Tip
          @if (odooOrder()?.paymentDetails?.tip?.isRecurrent) {
          <i class="fa fa-refresh" aria-hidden="true"></i>

          }
        </div>

        @if (tipAmount()) {
        <div class="col text-end animated fadeInRight">
          <div class="row d-flex justify-content-end">
            <div class="col-4 d-flex justify-content-end">
              <a (click)="openModalTip(updateTip)">Edit</a>
            </div>
            <div class="col-4 d-flex justify-content-center">
              {{ tipAmount() | currency }}
            </div>
            <div class="col-2">
              <i (click)="deleteTip()" class="fa fa-trash" aria-hidden="true"></i>
            </div>
          </div>
        </div>
        } @else {
        <div class="col text-end animated fadeInRight">
          <a (click)="openModalTip(createTip)" href="javascript:void(0)" class="badge text-black">Add</a>
        </div>
        }
      </div>
      }
      <!-- Donation -->
      @if (donationAmountVoluntary() && shouldShowTipsAndDonations()) {
      <div class="row row-cols-2 pt-2 justify-content-between animated fadeInRight">
        <div class="col">Donation
          @if (odooOrder()?.paymentDetails?.donation?.isRecurrent) {
          <i class="fa fa-refresh" aria-hidden="true"></i>
          }
        </div>
        <div class="col text-end">
          <div class="row d-flex justify-content-end">
            <div class="col-4 d-flex justify-content-end">
              <a (click)="openModalDonation(updateDonation)">Edit</a>
            </div>
            <div class="col-4 d-flex justify-content-center">
              {{ donationAmountVoluntary() | currency }}
            </div>
            <div class="col-2">
              <i (click)="deleteDonationVoluntary()" class="fa fa-trash" aria-hidden="true"></i>
            </div>
          </div>
        </div>
      </div>
      }

      <hr>

      <!-- Friend Referral -->
      @if (odooOrder()?.paymentDetails?.friendReferral) {
      <div class="row row-cols-2 justify-content-between">
        <div class="col">Friend Referral</div>
        <div class="col text-end">$0.00</div>
      </div>
      }

      <!-- Credits -->
      @if (creditsAmount()) {
      <div class="row row-cols-2 pt-2 justify-content-between">
        <div class="col">Applied credits</div>
        <div class="col text-end">{{ (appliedCredits()) | currency }}</div>
      </div>
      <!-- Credits -->
      <div class="row row-cols-2 pt-2 justify-content-between">
        <div class="col">Credit balance</div>
        <div class="col text-end">{{ (creditsBalance()) | currency }}</div>
      </div>
      <hr>
      }

      <!-- Seasonal Deposits -->
      @if (odooOrder()?.paymentDetails?.seasonalDeposits) {
      <div class="row row-cols-2 pt-2 justify-content-between">
        <div class="col">Seasonal Deposits</div>
        <div class="col text-end">{{ odooOrder()?.paymentDetails?.seasonalDeposits | currency }}</div>
      </div>
      <hr>
      }

      <!-- Deposits -->
      @if (odooOrder()?.paymentDetails?.desposits) {
      <div class="row row-cols-2 pt-2 justify-content-between">
        <div class="col">Desposits</div>
        <div class="col text-end">{{ odooOrder()?.paymentDetails?.desposits | currency }}</div>
      </div>
      <hr>
      }

      <!-- COUPON -->
      @if (odooOrder()?.paymentDetails?.coupons?.length) {
      <ul class="list-group list-group-flush mt-1">
        @for (coupon of odooOrder()?.paymentDetails?.coupons || []; track $index; let last = $last) {
        <li class="list-group-item px-0 py-2 d-flex justify-content-between align-items-start animated fadeIn border-0">
          <div class="me-3">
            <div class="fw-semibold">{{ coupon.discount }}</div>
          </div>
          <div class="text-end align-self-center">
            @if (coupon?.amount) {
            <span class="text-success fw-semibold">{{ coupon.amount | currency }}</span>
            } @else {
            <span class="badge bg-success-subtle text-success-emphasis fw-semibold">FREE PRODUCT</span>
            }
          </div>
        </li>
        @if (last) {
        <hr>
        }
        }
      </ul>
      }

      <!-- Saving -->
      @if (totalSavings()) {
      <div class="row animated fadeInRigth text-primary saving-card">
        <div class="col d-flex gap-1 align-content-center justify-content-center py-3">

          <span class="fw-bold">
            You're saving <strong>{{totalSavings() | currency}}</strong> on your order
          </span>

          <span class="material-symbols-outlined h5 cursor-pointer m-0"
            ngbTooltip="This total includes discounts, promotions, and coupons">
            info
          </span>

        </div>
      </div>
      <hr>
      }

      <!-- Total -->
      <div class="row row-cols-2 justify-content-between fw-bold fs-3">
        <div class="col">Total</div>
        <div class="col text-end text-primary fs-3 animated fadeIn">{{ total() | currency }}
        </div>
      </div>
    </div>

    <section>
      @if (odooOrder()?.id || (products()?.common?.length || products()?.subscription?.length)) {
      <div class="coupon-action">
        <div class="coupon-input">
          <div class="form">
            <input type="text" [(ngModel)]="coupon" placeholder="Enter coupon or gift certificate code"
              class="form-control" id="couponCode">
          </div>
        </div>
        <div>
          <button [disabled]="isUpdating()" (click)="applyCoupon()"
            class="btn btn-sm btn-outline-secondary">Apply</button>
        </div>
      </div>
      }

      @if (!donationAmountVoluntary() && hasVoluntaryDonationFlow()) {
      <div class="donation-action animated fadeInUp">
        <div class="">
          <small class="h7-regular">
            <a class="fw-bold" routerLink="/pages/about-us/donations" target="_blank">Learn more</a> about our donation
            program
          </small>
        </div>
        <div>
          <button class="btn btn-sm btn-outline-secondary fs-6" (click)="openModalDonation(createDonation)">Make a
            Donation
          </button>
        </div>
      </div>
      }
    </section>

    <div #orderActionWrap class="order-action-wrap d-grid" id="orderActionWrap">
      @if(showCouponErrorMessage()){
      <div class="order-action-alert alert alert-warning animated fadeIn mt-1 mb-3">
        <span class="alert-icon material-symbols-outlined">error</span>
        <div class="w-100">
          <p class="fw-semibold mb-0">This coupon couldn't be applied.</p>
          <span>{{couponErrorMessage()}}</span>
        </div>
      </div>
      }
      @if(hasPendingChanges()){
      <div class="order-action-alert alert alert-warning animated fadeIn">
        <i class="fa-solid fa-triangle-exclamation"></i> Cart is not saved!
      </div>
      } @else {
      <div class="order-action-alert alert alert-success animated fadeIn">
        <i class="fas fa-check"></i><b>Cart is saved!</b>
      </div>
      }
      @if (odooOrder()?.id) {
      <button type="button" class="btn btn-secondary" [disabled]="!hasPendingChanges() || isUpdating()"
        (click)="confirmOrder()">
        {{
        isUpdating()
        ? 'Updating Order...'
        : 'Update Order'
        }}
      </button>
      }
    </div>

    <!-- Skip deliveries -->
    @if (hasPreorderedProducts()) {
    <section class="pt-4">
      <app-empty-message [message]="preOrdersSkipDisclaimer()"></app-empty-message>
    </section>
    } @else {
    @if (!(isCheckedSkipWeekDelivery || odooOrder()?.isSkipped) && odooOrder()?.id) {
    <section class="d-flex justify-content-center">
      <div class="animated fadeIn">
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault"
            [(ngModel)]="isCheckedSkipWeekDelivery" (change)="onChangeSkipWeekDelivery()">
          <label class="form-check-label animated fadeIn h7-regular" for="flexSwitchCheckDefault">Skip this week's
            delivery</label>
        </div>
      </div>
    </section>
    }
    }

  </div>
  }
</div>